import React from 'react'
import "./ProcessCards.css"
import { useNavigate } from 'react-router-dom'

const processCardData=[
    {
        img:"/images/icons/process-icon-1.png",
        heading:"Deep Discovery",
        // content:"We get to know your brand at the core."
        content:"We get to know you, your team and your business at the core."
    },
    {
        img:"/images/icons/process-icon-2.png",
        heading:"Tailored Strategy",
        content:"We design a roadmap rooted in your truth."
    },
    {
        img:"/images/icons/process-icon-3.png",
        heading:"Creative Execution",
        content:"We bring your message to life-authentically."
    },
    {
        img:"/images/icons/process-icon-4.png",
        heading:"Collaborative Partnership",
        content:"We build with you, not just for you."
    },
    {
        img:"/images/icons/process-icon-5.png",
        heading:"Measurable Impact",
        content:"We track what matters and evolve as needed."
    },
    {
        img:"/images/icons/process-icon-6.png",
        heading:"Continuous Optimization",
        content:"Your brand grow-we grow with it."
    },
]

function ProcessCards() {
    const navigate = useNavigate()
  return (
    <div className='ProcessCards-container standard-padding-space'>
        <div className='container'>
            <div className='text-content text-center'>
                <h3 className='body-heading'>Our Process, Your Evolution</h3>

            </div>

            <div className='row mt-5 gy-3'>
                {
                    processCardData.map((ele)=>{
                        return(
                            <div className='col-lg-4 text-center'>
                                <img src={ele.img} alt='icon' className='img-fluid' />
                                <h3 className='mt-4 font-gpl' style={{fontWeight:"600"}} dangerouslySetInnerHTML={{__html:ele.heading}}></h3>
                                <p className='body-paragraph'>{ele.content}</p>

                            </div>
                        )
                    })
                }

            </div>

            <div className='w-100 text-center mt-4'>
                <button className='genral-btn btn-brown ' onClick={()=>{navigate("/contact")}}>
                    Book a Discovery Call
                </button>
            </div>
             
        </div>
    </div>
  )
}

export default ProcessCards